<template>
  <div>
    <div class="page flex-col">
      <div class="flex-col">
        <div class="group_1 flex-col justify-end">
          <div class="section_1 flex-row">
            <img
                class="image_1"
                referrerpolicy="no-referrer"
                src="./assets/img/c20ec8a3f9171b1d6dea111f0078fa61.webp"
            />
            <span class="text_1" :style="{ color: select('/home') ? 'rgba(22, 119, 255, 1)' : 'rgba(51, 51, 51, 1)' }" @click="handleJump('/home')">首页</span>
            <span class="text_2" :style="{ color: select('/about') ? 'rgba(22, 119, 255, 1)' : 'rgba(51, 51, 51, 1)' }" @click="handleJump('/about')">关于我们</span>
            <span class="text_3" :style="{ color: select('/system') ? 'rgba(22, 119, 255, 1)' : 'rgba(51, 51, 51, 1)' }" @click="handleJump('/system')">服务体系</span>
            <span class="text_4" :style="{ color: select('/case') ? 'rgba(22, 119, 255, 1)' : 'rgba(51, 51, 51, 1)' }" @click="handleJump('/case')">服务案例</span>
            <span class="text_5" :style="{ color: select('/join') ? 'rgba(22, 119, 255, 1)' : 'rgba(51, 51, 51, 1)' }" @click="handleJump('/join')">加入我们</span>
            <span class="text_6" :style="{ color: select('/contact') ? 'rgba(22, 119, 255, 1)' : 'rgba(51, 51, 51, 1)' }" @click="handleJump('/contact')">联系我们</span>
          </div>
          <div class="image-wrapper_1 flex-row" :style="getSelectStyle">
            <img
                class="image_2"
                referrerpolicy="no-referrer"
                src="./assets/img/3ec81dfb7664fff40323562f9abbc312.webp"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="page_box"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  computed: {
    select() {
      return function (url) {
        return this.$route.path === url;
      }
    },
    getSelectStyle() {
      let marginLeft = '';
      switch (this.$route.path) {
        case '/home':
          marginLeft = '45.93';
          // marginLeft = '882';
          break;
        case '/about':
          marginLeft = '51.4';
          // marginLeft = '987';
          break;
        case '/system':
          marginLeft = '57.7';
          // marginLeft = '1108';
          break;
        case '/case':
          marginLeft = '63.9';
          // marginLeft = '1227';
          break;
        case '/join':
          marginLeft = '70.15';
          // marginLeft = '1347';
          break;
        case '/contact':
          marginLeft = '76.4';
          // marginLeft = '1467';
          break;
        default:
          marginLeft = '45.93';
          // marginLeft = '882';
          break;
      }
      return {
        width: '3.34vw',
        height: '0.21vw',
        margin: `0.88vw 0 0 ${marginLeft}vw`,
      }
      // return {
      //   width: '64px',
      //   height: '4px',
      //   margin: `17px 0 0 ${marginLeft}px`,
      // };
    }
  },
  methods: {
    handleJump(url, data = {}) {
      if (url === this.$route.path) return;
      this.$router.push({
        path: url,
        query: data
      });
      window.scrollTo(0,0);
    }
  }
};
</script>
<style scoped lang="css" src="./assets/index.css" />
